module.exports = __webpack_public_path__ + "img/air_purple.f3867695.svg";